import React, { useEffect } from 'react';
import Dropzone from 'react-dropzone';
import { toastr } from 'react-redux-toastr';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Grid, Typography } from '@material-ui/core';
import { uniqueId } from 'lodash';
import { filesize } from 'filesize';

import TituloPagina from '../../components/layout/TituloPagina';
import VideoPreview from '../../components/templates/videoPreview';
import { verificarCompatibilidadeVideo } from '../../assets/js/validaVideo';

import {
    carregarUploadedFiles,
    addVideoProduto, // Nota: Se sua API/action mudar de nome para vídeos, lembre-se de atualizar aqui
    getProduto,
    getVideoProduto,
    deleteVideoProduto
} from '../../store/actions/produto';

import {
    Container,
    Content,
    DropContainer,
    UploadMessage
} from './styles';

const MAX_SIZE = 5000000; // 5MB
const MAX_VIDEO_DURATION = 15; // Limite em segundos

const UploadVideoUnicoProduto = props => {
    const location = useLocation();
    const history = useHistory();
    const id = Number(location?.state?.produtoId);
    const isEditRoute = location.pathname === '/produtos/video-do-produto';

    const {
        getProduto,
        produto,
        uploadedFiles,
        existingFiles,
        carregarUploadedFiles,
        addVideoProduto,
        deleteVideoProduto,
        getVideoProduto
    } = props;

    useEffect(() => {
        if (isEditRoute && !id) {
            history.replace('/produtos');
            return;
        }

        if (id > 0) {
            getProduto(id);
            getVideoProduto(id);
        }
    }, [getProduto, getVideoProduto, history, location]);

    useEffect(() => {
        if (existingFiles) {
            // Como aceita apenas 1, pegamos apenas o primeiro registro retornado pelo banco
            const file = existingFiles;
            const savedFile = [{
                id: file.id,
                idTemp: `db_${file.id}`,
                readableSize: null,
                preview: file.url,
                progress: 100,
                uploaded: true,
                error: false,
                url: file.url,
                idProduto: file.idProduto
            }];
            carregarUploadedFiles(savedFile);
        } else {
            carregarUploadedFiles([]);
        }

        return () => {
            uploadedFiles.forEach(file => {
                if (file.preview && file.preview.startsWith('blob:')) {
                    URL.revokeObjectURL(file.preview);
                }
            });
        };
    }, [existingFiles, carregarUploadedFiles]);

    const handleUpload = async (files) => {
        if (files.length === 0) return;

        // Pega apenas o primeiro arquivo enviado no evento atual
        const file = files[0];

        // Executa a nossa nova validação robusta
        const analise = await verificarCompatibilidadeVideo(file);

        if (!analise.valido) {
            toastr.error('Vídeo Inválido', analise.motivo);
            return;
        }

        const newUpload = {
            file,
            idTemp: uniqueId('upload_'),
            id: 0,
            readableSize: filesize(file.size),
            preview: URL.createObjectURL(file),
            progress: 0,
            uploaded: false,
            error: false,
            url: null,
            idProduto: produto.id
        };

        // Substitui qualquer arquivo anterior da lista pelo novo envio
        carregarUploadedFiles([newUpload]);

        // Dispara o upload do arquivo único
        addVideoProduto(newUpload);
    };

    const isUploading = uploadedFiles.some(f => !f.uploaded && !f.error);

    return (
        <>
            <TituloPagina titulo={`Vídeo para ${produto.nome || ''}`} />

            <Grid container item xs={12} style={{ padding: '15px 0' }}>
                <Typography variant="body1">
                    Selecione <strong>um único vídeo</strong> por produto. O formato deve ser <strong>MP4</strong> ou <strong>WebM</strong>, com no máximo <strong>{MAX_VIDEO_DURATION} segundos</strong> e até 5MB.
                </Typography>
            </Grid>

            <Container>
                <Content>
                    <Dropzone
                        accept={{
                            'video/mp4': ['.mp4'],
                            'video/webm': ['.webm']
                        }}
                        onDrop={handleUpload}
                        maxSize={MAX_SIZE}
                        multiple={false} // Desabilita a seleção de múltiplos arquivos de uma vez só
                    >
                        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                            <DropContainer
                                {...getRootProps()}
                                $isDragActive={isDragActive}
                                $isDragReject={isDragReject}
                            >
                                <input {...getInputProps()} />
                                {!isDragActive && <UploadMessage>Clique ou arraste o vídeo aqui.</UploadMessage>}
                                {isDragActive && !isDragReject && <UploadMessage type="success">Solte para enviar!</UploadMessage>}
                                {isDragReject && <UploadMessage type="error">Arquivo inválido. Escolha apenas um vídeo MP4/WebM de até 20MB.</UploadMessage>}
                            </DropContainer>
                        )}
                    </Dropzone>

                    {uploadedFiles.length > 0 && (
                        <VideoPreview
                            files={uploadedFiles}
                            onDelete={deleteVideoProduto}
                        />
                    )}
                </Content>
            </Container>

            <Grid container style={{ marginTop: '20px' }}>
                <Button
                    variant='contained'
                    color='primary'
                    disabled={isUploading}
                    href='/produtos'
                >
                    {isUploading ? 'Enviando...' : 'Finalizar'}
                </Button>
            </Grid>
        </>
    );
};

const mapStateToProps = state => ({
    produto: state.produto.produto,
    uploadedFiles: state.produto.uploadedFiles,
    video: state.produto.video,
    existingFiles: state.produto.existingFiles
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getProduto,
            getVideoProduto,
            carregarUploadedFiles,
            addVideoProduto,
            deleteVideoProduto
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UploadVideoUnicoProduto);